import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/gold-onboard-image.svg'


const _withScopeId = n => (_pushScopeId("data-v-108bcfd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-bottom-gold-onboard-section" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\" data-v-108bcfd6><div class=\"modal-header-bg\" data-v-108bcfd6></div><img class=\"modal-header-image\" src=\"" + _imports_0 + "\" data-v-108bcfd6></div><div class=\"modal-body\" data-v-108bcfd6><span class=\"modal-body-title\" data-v-108bcfd6>ยินดีด้วย! คุณได้อัปเกรดเป็น Gold Member</span><span class=\"modal-body-description\" data-v-108bcfd6>พบกับสิทธิพิเศษเหนือระดับมากมาย​</span><span class=\"modal-body-description\" data-v-108bcfd6>สะสมยอดช้อปต่อเนื่อง เพื่อรักษาสถานะของท่าน</span></div>", 2)
const _hoisted_5 = { class: "modal-footer" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "btn",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.closeModal()))
        }, "ตกลง")
      ])
    ])
  ]))
}